import React, { useState } from 'react';

const ContactSection = () => {
  const [form, setForm] = useState({ name: '', email: '', phone: '', message: '' });
  const [status, setStatus] = useState(null); // null | 'sending' | 'ok' | 'error'
  const [errorMsg, setErrorMsg] = useState('');

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('sending');
    setErrorMsg('');

    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content;

    try {
      const res = await fetch('/contato', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': csrfToken || '',
        },
        body: JSON.stringify(form),
      });

      const data = await res.json();

      if (res.ok) {
        setStatus('ok');
        setForm({ name: '', email: '', phone: '', message: '' });
      } else {
        setStatus('error');
        setErrorMsg(data.error || 'Falha ao enviar. Tente novamente.');
      }
    } catch {
      setStatus('error');
      setErrorMsg('Falha ao enviar. Verifique sua conexão e tente novamente.');
    }
  };

  return (
    <section className="bg-[#0A0F14] py-20" id="contato">
      {/* accent strip */}
      <div className="h-px w-full bg-gradient-to-r from-transparent via-brand-500/40 to-transparent mb-16" aria-hidden="true" />

      <div className="container mx-auto px-4 max-w-2xl">
        {/* heading */}
        <div className="text-center mb-12">
          <p className="font-display text-xs font-bold uppercase tracking-[0.25em] text-brand-300 mb-3">
            Fale Conosco
          </p>
          <h2 className="font-display text-4xl md:text-5xl font-extrabold text-white leading-tight">
            Entre em Contato
          </h2>
          <p className="mt-4 text-gray-400 text-base max-w-lg mx-auto">
            Tire dúvidas, solicite uma cotação ou fale com nossa equipe. Respondemos em até 1 dia útil.
          </p>
        </div>

        {status === 'ok' ? (
          <div className="rounded-xl border border-brand-500/30 bg-brand-500/10 p-10 text-center">
            <svg className="w-12 h-12 text-brand-300 mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <h3 className="font-display text-2xl font-bold text-white mb-2">Mensagem enviada!</h3>
            <p className="text-gray-400">Nossa equipe entrará em contato em breve.</p>
            <button
              onClick={() => setStatus(null)}
              className="mt-6 text-sm font-semibold text-brand-300 hover:text-brand-200 transition-colors"
            >
              Enviar outra mensagem
            </button>
          </div>
        ) : (
          <form onSubmit={handleSubmit} noValidate className="space-y-5">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
              {/* Nome */}
              <div>
                <label className="block text-xs font-bold uppercase tracking-[0.15em] text-gray-400 mb-2">
                  Nome <span className="text-brand-400">*</span>
                </label>
                <input
                  type="text"
                  name="name"
                  value={form.name}
                  onChange={handleChange}
                  required
                  placeholder="Seu nome"
                  className="w-full bg-white/5 border border-white/10 rounded-lg px-4 py-3 text-white placeholder-gray-600 text-sm focus:outline-none focus:border-brand-400 focus:bg-white/8 transition-colors"
                />
              </div>

              {/* Email */}
              <div>
                <label className="block text-xs font-bold uppercase tracking-[0.15em] text-gray-400 mb-2">
                  E-mail <span className="text-brand-400">*</span>
                </label>
                <input
                  type="email"
                  name="email"
                  value={form.email}
                  onChange={handleChange}
                  required
                  placeholder="seu@email.com"
                  className="w-full bg-white/5 border border-white/10 rounded-lg px-4 py-3 text-white placeholder-gray-600 text-sm focus:outline-none focus:border-brand-400 focus:bg-white/8 transition-colors"
                />
              </div>
            </div>

            {/* Telefone */}
            <div>
              <label className="block text-xs font-bold uppercase tracking-[0.15em] text-gray-400 mb-2">
                Telefone / WhatsApp
              </label>
              <input
                type="tel"
                name="phone"
                value={form.phone}
                onChange={handleChange}
                placeholder="(51) 9 0000-0000"
                className="w-full bg-white/5 border border-white/10 rounded-lg px-4 py-3 text-white placeholder-gray-600 text-sm focus:outline-none focus:border-brand-400 focus:bg-white/8 transition-colors"
              />
            </div>

            {/* Mensagem */}
            <div>
              <label className="block text-xs font-bold uppercase tracking-[0.15em] text-gray-400 mb-2">
                Mensagem <span className="text-brand-400">*</span>
              </label>
              <textarea
                name="message"
                value={form.message}
                onChange={handleChange}
                required
                rows={5}
                placeholder="Como podemos ajudar? Descreva sua necessidade..."
                className="w-full bg-white/5 border border-white/10 rounded-lg px-4 py-3 text-white placeholder-gray-600 text-sm focus:outline-none focus:border-brand-400 focus:bg-white/8 transition-colors resize-none"
              />
            </div>

            {status === 'error' && (
              <p className="text-red-400 text-sm">{errorMsg}</p>
            )}

            <button
              type="submit"
              disabled={status === 'sending'}
              className="w-full bg-brand-500 hover:bg-brand-400 disabled:opacity-60 disabled:cursor-not-allowed text-white font-display font-bold text-base uppercase tracking-[0.1em] py-4 rounded-lg transition-colors"
            >
              {status === 'sending' ? 'Enviando…' : 'Enviar Mensagem'}
            </button>
          </form>
        )}
      </div>
    </section>
  );
};

export default ContactSection;
